import * as angular from 'angular';

import { ByApplicationChart } from './LogsByApplication.chart';
import { ComponentDefinition } from '../../../models';

class LogsByApplicationController implements angular.IComponentController {
    readonly isLoading: boolean;
    readonly logs: any[];

    private _chart: ByApplicationChart;

    static $inject = ['$element'];

    constructor(private _$element: any) {
    }

    $onInit() {
        this._chart = new ByApplicationChart(this._$element
            .children('.widget-content')[0])
            .groupBy(d => d.application);
        this._$element
            .resize(() => {
                const w = this._$element.width();
                const h = this._$element.height();
                this._chart.size({ width: w, height: h });
            });
        if (this.logs) {
            this._chart.update(this.logs);
        }
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['logs']?.currentValue && this._chart) {
            this._chart.update(changesObj['logs'].currentValue);
        }
    }
}

export const wtLogsByApplication: ComponentDefinition = {
    componentId: 'wtLogsByApplication',
    controller: LogsByApplicationController,
    template: require('./LogsByApplication.component.html'),
    controllerAs: 'vm',
    bindings: {
        logs: '<',
        isLoading: '<'
    }
};
